import SlideOver from './SlideOver';

export default SlideOver;
